import React, { useState } from "react";
import "./header.css";
import Icons from "../../config/images";
import { useNavigate, useLocation } from "react-router-dom";

const Header = () => {
  const navigate = useNavigate();
  const location = useLocation(); // get current route
  const [menuOpen, setMenuOpen] = useState(false);

  const handleClick = (path) => {
    navigate(path); // Navigate to the route
    window.scrollTo({ top: 0 }); // Scroll to top
    setMenuOpen(false); // Close mobile menu if open
  };

  return (
    <div className="header-style">
      <nav className="navbar-section">
        <div className="navbar-flex-row-style">
          <img
            src={Icons.logo}
            alt="Office Logo"
            className="logo-image-style"
            onClick={() => handleClick("/")}
          />

          <div
            className={`hamburger-icon ${menuOpen ? "open" : ""}`}
            onClick={() => setMenuOpen(!menuOpen)}
          >
            <span></span>
            <span></span>
            <span></span>
          </div>
        </div>

        <ul className={`nav-links ${menuOpen ? "show" : ""}`}>
          <li
            className={`nav-link-text ${location.pathname === "/" ? "active" : ""}`}
            onClick={() => handleClick("/")}
          >
            Home
          </li>
          <li
            className={`nav-link-text ${location.pathname === "/services" ? "active" : ""}`}
            onClick={() => handleClick("/services")}
          >
            Services
          </li>
          <li
            className={`nav-link-text ${location.pathname === "/about" ? "active" : ""}`}
            onClick={() => handleClick("/about")}
          >
            About Us
          </li>
          <li
            className={`nav-link-text ${location.pathname === "/career" ? "active" : ""}`}
            onClick={() => handleClick("/career")}
          >
            Career
          </li>
          <li
            className={`nav-link-text ${location.pathname === "/contact-us" ? "active" : ""}`}
            onClick={() => handleClick("/contact-us")}
          >
            Contact Us
          </li>
        </ul>

        {/* SOCIAL ICONS */}
        <div className="social-icons">
          {/* <a href="https://facebook.com" target="_blank" rel="noreferrer">
            <img src={Icons.facebookIcon} alt="Facebook" />
          </a> */}
          <a href="https://www.linkedin.com/in/ba-code-solutions-45709730b/" target="_blank" rel="noreferrer">
            <img src={Icons.linkedInIcon} alt="LinkedIn" />
          </a>
          <a href="https://www.instagram.com/bacodesolutions" target="_blank" rel="noreferrer">
            <img src={Icons.instagramIcon} alt="Instagram" />
          </a>
          <a href="https://wa.me/919974894099" target="_blank" rel="noreferrer">
            <img src={Icons.whatsappIcon} alt="WhatsApp" />
          </a>
        </div>
      </nav>
    </div>
  );
};

export default Header;
